module.exports = __webpack_public_path__ + "img/hcml_detail.90e18351.jpg";